import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { AuthGate } from "./components/AuthGate";
import { CaptureTierProvider } from "./captureTierProvider";
import { EditPopupProvider } from "./components/EditPopupProvider";
import { EditModeProvider } from "./layout/editMode";
import { FireworksProvider } from "./components/Fireworks";
import { RouterProvider } from "./router";
import { installOfflineMirror } from "./offlineMirror";
import "./styles.css";

// Before anything renders: `api.ts` cannot import the mirror (it is imported *by* it), so
// the ability to answer a read locally is handed to it here, once, explicitly (§8.2, D169).
installOfflineMirror();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider>
      <AuthGate>
        <FireworksProvider>
          <CaptureTierProvider>
            <EditModeProvider>
              <EditPopupProvider>
                <App />
              </EditPopupProvider>
            </EditModeProvider>
          </CaptureTierProvider>
        </FireworksProvider>
      </AuthGate>
    </RouterProvider>
  </StrictMode>,
);
